<template>
    <section>
        <router-view />
    </section>
</template>
